// store/slices/uiSlice.js
import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    confirmDialog: { show: false, message: '', onConfirm: () => {} },
    alertDialog:   { show: false, message: '', severity: 'warning' } // NEW
  },
  reducers: {
    showConfirm: (state, action) => {
      state.confirmDialog = {
        show: true,
        message: action.payload.message,
        onConfirm: action.payload.onConfirm
      };
    },
    hideConfirm: (state) => { state.confirmDialog.show = false; },

    // NEW: OK-only alert
    showAlert: (state, action) => {
      const { message, severity = 'warning' } = action.payload || {};
      state.alertDialog = { show: true, message, severity };
    },
    hideAlert: (state) => { state.alertDialog.show = false; },
  }
});

export const { showConfirm, hideConfirm, showAlert, hideAlert } = uiSlice.actions;
export default uiSlice.reducer;
